import { render, staticRenderFns } from "./productLabelTableNew.vue?vue&type=template&id=85037da6&"
import script from "./productLabelTableNew.vue?vue&type=script&lang=js&"
export * from "./productLabelTableNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports